import React from 'react';

import { Props } from './VehicleCluster.types';
import { setRouteTypeColors } from '../../../consts/vehicles';
import { clusterIcon } from '../Map/ReducedMap/Icons';
import { RType } from '../../../types/vehicles';
import { transportSelectedMarkerIcon } from '../Video/MapComponent/icons';
import { GeoJSON } from 'leaflet';
import { Marker } from 'react-leaflet';

export const VehicleCluster: React.FC<Props> = ({ cluster, onSelectVehicle, onChangeMapSettings, mapSettings }) => {
  const routeType = Object.keys(cluster.parts)[0];

  const routeTypeColor = setRouteTypeColors()[routeType];

  const course = cluster.course ? cluster.course : 0;
  const fill = cluster.on ? routeTypeColor : '#CDCDCD';

  const icon =
    cluster.size > 1
      ? clusterIcon({
          routeType: Object.keys(cluster.parts)[0] as RType,
          size: cluster.size,
          isVehicle: true
        })
      : transportSelectedMarkerIcon(course, fill, false, true);

  const onClick = () => {
    cluster.size === 1
      ? onSelectVehicle?.(cluster.id as number)
      : onChangeMapSettings({
          center: GeoJSON.coordsToLatLng([
            cluster.coords[0],
            cluster.coords[1],
          ]),
          zoom: mapSettings.zoom + 2,
        });
  };

  return (
    <Marker
      position={GeoJSON.coordsToLatLng([cluster.coords[0], cluster.coords[1]])}
      icon={icon}
      onClick={onClick}
    />
  );
};
